import { render, staticRenderFns } from "./ResendSignUp.vue?vue&type=template&id=60dfc205&scoped=true"
import script from "./ResendSignUp.vue?vue&type=script&lang=js"
export * from "./ResendSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dfc205",
  null
  
)

export default component.exports